import { FOCUS_RING } from "@packages/design-system/constants";
import { cn } from "@packages/lib/utils";
import * as React from "react";

const TextArea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea"> & {
    "aria-invalid"?: boolean;
  }
>(({ className, "aria-invalid": ariaInvalid, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "border-input placeholder:text-muted-foreground flex min-h-12 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs disabled:cursor-not-allowed disabled:opacity-50 md:text-sm/6",
        FOCUS_RING,
        ariaInvalid && "border-destructive",
        className,
      )}
      ref={ref}
      aria-invalid={ariaInvalid}
      {...props}
    />
  );
});
TextArea.displayName = "TextArea";

export { TextArea };
